import { makeStyles } from "@material-ui/styles"

export default makeStyles((theme) => ({
	root: {
		border: `1px solid ${theme.palette.primary.dark}`,
		textAlign: "center",
		minHeight: 225,
		borderRadius: "10px",
		cursor: "pointer",
		backgroundColor: theme.palette.grey["100"],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	dropZoneContainer: {
		padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
	},
	textBlue: {
		color: theme.palette.primary.dark,
		fontWeight: 500,
	},
	textBlack: {
		color: theme.palette.common.black,
		fontWeight: 500,
	},
	dividerLine: {
		width: "100%",
		border: `1px solid ${theme.palette.grey[400]}`,
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
	},
	row: {
		padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
	},
	button: {
		textTransform: "capitalize",
	},
	buttonWrapper: {
		display: "flex",
		justifyContent: "space-between",
		gap: theme.spacing(1),
	},
	btnCancel: {},
	btnUpload: {
		backgroundColor: theme.palette.primary.dark,
		fontWeight: 500,
	},
	fileName: {
		color: theme.palette.text.primary,
		maxWidth: "75%",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden",
		marginBottom: 0,
	},
	fileSize: {
		color: theme.palette.grey[400],
		marginLeft: theme.spacing(1),
		marginBottom: 0,
	},
	fileList: {
		marginTop: theme.spacing(2),
	},
	listWrapper: {
		maxHeight: "15vh",
		overflowY: "auto",
	},
	listItem: {
		minHeight: 44,
	},
}))
